import React from 'react';

import SvgIcon from '../SvgIcon';
import type { IconProps } from '../types';

const TrashIcon: React.FC<IconProps> = ({ className, size, disabled }) => (
  <SvgIcon
    viewBox="0 0 24 24"
    className={className}
    size={size}
    disabled={disabled}
    strokeWidth={0}
    fill="currentColor"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.32503 2.15901C8.74698 1.73705 9.31928 1.5 9.91602 1.5H14.416c.5968 0 1.169.23705 1.591.65901.422.42196.659.99425.659 1.59099v.75h3.75c.4142 0 .75.33579.75.75s-.3358.75-.75.75h-.75v13.5c0 .3978-.158.7794-.4393 1.0607S18.5638 21 18.166 21H6.16602c-.39783 0-.77936-.158-1.06066-.4393-.28131-.2813-.43934-.6629-.43934-1.0607V6h-.75c-.41422 0-.75-.33579-.75-.75s.33578-.75.75-.75h3.75v-.75c0-.59674.23705-1.16903.65901-1.59099ZM6.16602 6v13.5H18.166V6H6.16602ZM15.166 4.5H9.16602v-.75c0-.19891.07901-.38968.21967-.53033C9.52634 3.07902 9.7171 3 9.91602 3H14.416c.1989 0 .3897.07902.5303.21967.1407.14065.2197.33142.2197.53033v.75ZM9.91602 9c.41418 0 .74998.33579.74998.75v6c0 .4142-.3358.75-.74998.75-.41422 0-.75-.3358-.75-.75v-6c0-.41421.33578-.75.75-.75Zm3.74998.75c0-.41421.3358-.75.75-.75s.75.33579.75.75v6c0 .4142-.3358.75-.75.75s-.75-.3358-.75-.75v-6Z"
    />
  </SvgIcon>
);

export default TrashIcon;
